import React from 'react';
import ObliqueIcon from '@/components/icons/ObliqueIcon';
import { Button } from '@/components/ui/button';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        if (error?.message?.includes('INTERNAL ASSERTION FAILED') || String(error)?.includes('INTERNAL ASSERTION FAILED')) {
            console.warn('[ErrorBoundary] Suppressed Firestore internal SDK transport assertion failure:', error);
            return { hasError: false, error: null };
        }
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (error?.message?.includes('INTERNAL ASSERTION FAILED') || String(error)?.includes('INTERNAL ASSERTION FAILED')) {
            console.warn('[ErrorBoundary] Ignored uncaught Firestore assertion failure:', error);
            return;
        }
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback(this.state.error, this.handleReset);
            }

            return (
                <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-subtle rounded-xl border m-4">
                    <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-500 mb-4">
                        <ObliqueIcon name="error_outline" size={24} />
                    </div>
                    <h3 className="text-lg font-semibold text-primary mb-2">Something went wrong</h3>
                    <p className="text-sm text-tertiary mb-6 max-w-md">
                        {this.state.error?.message || "An unexpected error occurred while rendering this module."}
                    </p>
                    <Button onClick={this.handleReset} variant="outline" className="gap-2">
                        <ObliqueIcon name="refresh" size={16} />
                        Try again
                    </Button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
